import React, { FC } from 'react';
import {
  Box,
  Step,
  StepIcon,
  StepIndicator,
  StepNumber,
  Stepper,
  StepSeparator,
  StepStatus,
  StepTitle
} from '@chakra-ui/react';
import { useLiquidityWizardState } from '@app/screens/liquidity/LiquidityWizard/state';

import s from './WizardStepper.module.scss';
import clsx from 'clsx';

const steps = [
  { title: 'Select Tokens' },
  { title: 'Select Mode' },
  { title: 'Complete' }
];

export const WizardStepper: FC = () => {
  const {
    step,
    actions: { setStep }
  } = useLiquidityWizardState();

  return (
    <Stepper index={step} colorScheme="red" className={s.stepper}>
      {steps.map((_step, index) => (
        <Step
          key={index}
          className={clsx(s.step)}
          onClick={() => {
            if (index > step) {
              return;
            }

            setStep(index);
          }}
        >
          <StepIndicator
            className={clsx(s.indicator, {
              [s.clickable]: index <= step
            })}
          >
            <StepStatus
              complete={<StepIcon />}
              incomplete={<StepNumber />}
              active={<StepNumber />}
            />
            <Box flexShrink="0" className={s.titleWrapper}>
              <StepTitle className={s.title}>{_step.title}</StepTitle>
            </Box>
          </StepIndicator>
          <StepSeparator className={s.separator} />
        </Step>
      ))}
    </Stepper>
  );
};
